module.exports = __webpack_public_path__ + "assets/img/bg4.c1ff7867.gif";